module.exports = __webpack_public_path__ + "img/logo-cbmmg.64ce29f8.png";